<mat-expansion-panel displayMode="flat" [expanded]="expanded" (opened)="onPanelToggle()" (closed)="onPanelToggle()">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <p>Original File Metadata</p>
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-container>
    <div id="templateAction_ListContainer">
      <div class="row row-container">
        <div class="column">
          <div class="heading ">Type Of File</div>
          <span
            class="file-type"
            [attr.id]="buildControlId('file-type-value')"
          >{{
            clickedBucketItem.ExtensionForFile
          }}</span>
        </div>
        <div class="column">
          <div class="heading ">Size</div>
          <span class="file-type"
          matTooltipClass="tooltip-style" 
          matTooltipPosition="below"
          [matTooltip]="fileSizeInBytes"
          [matTooltipDisabled]="fileSize === '0 Bytes' || fileSize.endsWith('Bytes')"
          [attr.id]="buildControlId('file-size-value')">{{
            fileSize
          }}</span>
        </div>
      </div>
      <div class="row">
        <div class="column">
          <div class="heading mb-5">Modified On</div>
          <div class="modified-on">
            <div>{{ clickedBucketItem.FileLastModifiedOn + "Z" | date : "dd MMM yyyy" }}</div>
            <div class="m-t-xs">
              {{ clickedBucketItem.FileLastModifiedOn + "Z" | date : "HH:mm:ss" }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</mat-expansion-panel>
